import { LitElement } from "lit-element";

export class StofwarePageElement extends LitElement {
	shouldUpdate(changedProperties) {
		return this.active;
	}

	static get properties() {
		return {
			active: { type: Boolean }
		};
	}
}
